import { ToolType } from "@/modules/ToolModule";
import { Layer2Component } from '@/stellar-globe-components';
import { Frame, store } from "@/store";
import { Globe, RollLayer, TouchLayer, ZoomLayer } from "@hscmap/stellar-globe";
import { Component, Prop, Vue } from "vue-property-decorator";
import ContextMenu from "./ContextMenu/index.vue";

@Component({
  components: {
    ContextMenu,
    ZoomLayer: Layer2Component(ZoomLayer),
    RollLayer: Layer2Component(RollLayer),
    TouchLayer: Layer2Component(TouchLayer),
  },
})
export default class FrameComponent extends Vue {
  @Prop({ required: true })
  frame!: Frame

  @Prop({ default: 200 })
  viewUpdateDelay!: number

  @Prop({ default: false })
  showFrameTool!: boolean

  globe!: Globe

  load(globe: Globe) {
    this.globe = globe
    store.globeRegister(this.frame, globe)
  }

  beforeDestroy() {
    store.globeUnregister(this.frame)
    window.removeEventListener('resize', this.onresize)
    window.removeEventListener('orientationchange', this.onresize)
  }

  onresize!: () => void
  mounted() {
    this.resize()
    window.addEventListener('resize', this.onresize = () => this.resize())
    window.addEventListener('orientationchange', this.onresize = () => this.resize())
  }

  resize() {
    this.globe.resize()
  }

  get cursor() {
    if (store.cursor) {
      return store.cursor
    }
    switch (store.modules.tool.type) {
      case ToolType.PAN:
        return 'default'
      default:
        return 'crosshair'
    }
  }
}
